(() => {
  "use strict";
  var __webpack_exports__ = {};
  (function (ProductTemplate) {
    let U;
    let Cart;
    let ProductCard;
    let ProductCardSlider;
    let Modal;
    let Video;
    let QuantityInput;
    const sections = Object.create(null);
    const sliderArrowShape = { x0: 20, x1: 60, y1: 35, x2: 65, y2: 25, x3: 45 };
    let product;
    let variantIdToData;
    const addProductToRecentlyViewed = function (newHandle) {
      const savedHandles = U.getRecentlyViewedProductHandles();
      const maxNumHandles = 20;
      const newHandleSavedIndex = savedHandles.indexOf(newHandle);
      if (newHandleSavedIndex !== -1) {
        savedHandles.splice(newHandleSavedIndex, 1);
      }
      while (savedHandles.length > maxNumHandles - 1) {
        savedHandles.shift();
      }
      savedHandles.push(newHandle);
      U.setCookie(
        PLUG.recentlyViewedCookieName,
        savedHandles.join(","),
        3456e4,
        { path: "/" }
      );
    };
    ProductTemplate.export = function () {
      U = PLUG.import("Utils");
      Cart = PLUG.import("Frame").cart;
      Modal = PLUG.import("Modal");
      Video = PLUG.import("Video");
      QuantityInput = PLUG.import("QuantityInput");
      ProductCard = PLUG.import("ProductCard");
      ProductCardSlider = PLUG.import("ProductCardSlider");
      product = JSON.parse(document.getElementById("product-json").innerHTML);
      variantIdToData = JSON.parse(
        document.getElementById("product-inventory-json").innerHTML
      ).variants;
      return Object.freeze({
        init: function () {
          try {
            addProductToRecentlyViewed(product.handle);
          } catch (exception) {
            console.error(exception);
          }
          sections.productMain = ProductMain();
          sections.productRecommendations = ProductRecommendations();
          sections.productArticles = ProductArticles();
          sections.productVideos = ProductVideos();
          sections.productCollage = ProductCollage();
          sections.productCompare = ProductCompare();
        },
      });
    };
    function ProductMain() {
      const productMainSubsections = Object.create(null);
      const sliderEle = document.getElementsByClassName(
        "p-main-media-slider"
      )[0];
      const mediaItems = sliderEle.getElementsByClassName("p-main-media-item");
      const productForm = document.getElementById("p-main-product-form");
      const variantIdSelect = document.getElementById(
        "p-main-variant-id-select"
      );
      const quantityInput = document.getElementById("p-main-qty-input");
      const priceAndSkuContainer = document.getElementsByClassName(
        "p-main-price-and-sku-container"
      )[0];
      const priceEle = priceAndSkuContainer.getElementsByClassName("price")[0];
      const compareAtPriceEle =
        priceAndSkuContainer.getElementsByClassName("compare-at-price")[0];
      const skuEle = document.getElementById("p-main-sku");
      const specTableSkuEle = document.getElementById("p-main-specs-sku");
      const addToCartBtn = document.getElementById("p-main-add-to-cart");
      const altPaymentBtnWrapper = document.getElementById(
        "p-main-alt-payment-btn-wrapper"
      );
      const installmentPaymentsMinPrice = document.getElementById(
        "p-main-installment-payments-min-price"
      );
      const favButton = document.querySelector(".plug-fav-button--pdp");
      let slider;
      const isGiftCard = !!(
        addToCartBtn && addToCartBtn.dataset.isGiftCard === "true"
      );
      let giftCardRecipientForm;
      if (isGiftCard) {
        giftCardRecipientForm =
          productForm.getElementsByTagName("recipient-form")[0];
      }
      (function init() {
        productMainSubsections.productMedia = ProductMedia();
        productMainSubsections.productOptions = ProductOptions();
        productMainSubsections.productQuantity = ProductQuantity();
        productMainSubsections.productTabMenu = ProductTabMenu();
        productMainSubsections.productAddons = ProductAddons();
        addToCartBtn.addEventListener("click", addToCart);
        if (
          altPaymentBtnWrapper.getElementsByClassName(
            "shopify-payment-button__button--unbranded"
          ).length
        ) {
          setTimeout(function () {
            altPaymentBtnWrapper.classList.remove("is-translucent");
          }, 300);
        }
        U.addListenerToFavButton(favButton);
        U.updateAllFavoriteButtons()
          .then(() => {
            favButton.classList.remove("is-translucent");
          })
          .catch((err) => console.error(err));
      })();
      function ProductMedia() {
        const productMainMedia =
          document.getElementsByClassName("p-main-media")[0];
        const sliderContainer = document.getElementsByClassName(
          "p-main-media-slider-container"
        )[0];
        (function init() {
          try {
            if (!mediaItems.length) return;
            initSlider();
            setupMagnifyEffects();
            setupVideos();
            setupThumbnails();
            setupStickyScroll();
            setupModelModal();
            setupModelAr();
            const firstMediaId = mediaItems[0].dataset.mediaId;
            const model = document.querySelector(
              `product-model[data-media-id="${firstMediaId}"]`
            );
            if (model) {
              setTimeout(function () {
                model.loadContent();
              });
            }
            slider.on("change", function (index) {
              const mediaItem = mediaItems[index];
              if (mediaItem.dataset.mediaType === "image") {
                const bigImage =
                  mediaItem.getElementsByClassName("ratio-img-2x-zoom")[0];
                if (bigImage.dataset.plugLoaded !== "true") {
                  bigImage.dataset.plugLoaded = "true";
                  bigImage.classList.add("lazypreload");
                }
              } else if (mediaItem.dataset.mediaType === "external_video") {
                const iframe = mediaItem.querySelector(
                  "iframe.ratio-box-content"
                );
                if (iframe.dataset.src && !iframe.src) {
                  iframe.src = iframe.dataset.src;
                }
              }
              setActiveMediaItem(mediaItem.dataset.mediaId, true);
            });
          } catch (exception) {
            console.log("Error setting up product media.", exception);
          }
        })();
        function initSlider() {
          slider = new Flickity(sliderEle, {
            wrapAround: true,
            pageDots: false,
            arrowShape: sliderArrowShape,
          });
          U.removeClasses(mediaItems, "is-translucent");
        }
        function setupMagnifyEffects() {
          let k = 0;
          while (k < mediaItems.length) {
            const mediaItemK = mediaItems[k];
            if (mediaItemK.dataset.mediaType === "image") {
              initMagnifyOnHoverEffect(
                mediaItemK.getElementsByClassName("ratio-box")[0],
                mediaItemK.getElementsByClassName("ratio-img-1x-zoom")[0],
                mediaItemK.getElementsByClassName("ratio-img-2x-zoom")[0]
              );
            }
            k += 1;
          }
        }
        function initMagnifyOnHoverEffect(container, mini, maxi) {
          let rect = container.getBoundingClientRect();
          container.addEventListener(
            "mouseenter",
            function () {
              if (!U.isMobile()) {
                maxi.classList.add("show");
                rect = container.getBoundingClientRect();
              }
            },
            false
          );
          const mousemoveThrottler = U.throttlerConstructor();
          container.addEventListener(
            "mousemove",
            function (event) {
              if (!U.isMobile()) {
                mousemoveThrottler(function () {
                  if (!rect) {
                    return;
                  }
                  const left = event.pageX;
                  const top = event.pageY - 5;
                  const imageTop = Math.max(top - (rect.top + scrollY), 0);
                  const imageLeft = Math.max(left - rect.left, 0);
                  const imageTopPercent = imageTop / rect.height;
                  const imageLeftPercent = imageLeft / rect.width;
                  const widthDifference = maxi.offsetWidth - mini.offsetWidth;
                  const heightDifference =
                    maxi.offsetHeight - mini.offsetHeight;
                  const newMaxiTop = -1 * heightDifference * imageTopPercent;
                  const newMaxiLeft = -1 * widthDifference * imageLeftPercent;
                  maxi.style.top = newMaxiTop + "px";
                  maxi.style.left = newMaxiLeft + "px";
                });
              }
            },
            false
          );
          container.addEventListener(
            "mouseleave",
            function () {
              rect = undefined;
              maxi.classList.remove("show");
            },
            false
          );
          container.addEventListener("scroll", function () {
            rect = undefined;
          });
        }
        function setupVideos() {
          const videoElements = sliderEle.getElementsByTagName("video");
          const videos = [];
          if (!videoElements.length) {
            return;
          }
          let k = 0;
          while (k < videoElements.length) {
            videos.push(Video.init(videoElements[k]));
            k += 1;
          }
          if (
            product.media.some((media) => media.media_type === "video") &&
            sliderEle.dataset.autoplayVideos === "true"
          ) {
            videos[0].play();
          }
        }
        function setupThumbnails() {
          const thumbnails =
            document.getElementsByClassName("p-main-thumbnail");
          setupClickHandlers();
          setupScrollButtons();
          function setupClickHandlers() {
            let k = 0;
            while (k < thumbnails.length) {
              const thumbnailK = thumbnails[k];
              thumbnailK.addEventListener("click", function () {
                const mediaId = thumbnailK.dataset.mediaId;
                setActiveMediaItem(mediaId);
              });
              k += 1;
            }
          }
          function setupScrollButtons() {
            const scrollUpButton = document.getElementById(
              "p-main-thumbnails-scroll-up-btn"
            );
            const scrollDownButton = document.getElementById(
              "p-main-thumbnails-scroll-down-btn"
            );
            const thumbnailsContainer =
              document.getElementsByClassName("p-main-thumbnails")[0];
            if (!scrollUpButton) {
              return;
            }
            scrollUpButton.addEventListener("click", function () {
              scrollThumbnails("up");
            });
            scrollDownButton.addEventListener("click", function () {
              scrollThumbnails("down");
            });
            thumbnailsContainer.addEventListener("scroll", function () {
              if (!U.isMobile() && thumbnailsContainer.scrollTop > 0) {
                scrollUpButton.classList.remove("is-hidden");
              } else {
                scrollUpButton.classList.add("is-hidden");
              }
            });
            function scrollThumbnails(direction) {
              const totalScrollHeight = thumbnailsContainer.scrollHeight;
              const currentScroll = thumbnailsContainer.scrollTop;
              const thumbnailHeight =
                thumbnails[0].getBoundingClientRect().height + 22;
              let newScrollTop;
              let roomLeftToScroll;
              if (direction === "down") {
                const containerHeight =
                  thumbnailsContainer.getBoundingClientRect().height;
                if (currentScroll + containerHeight < totalScrollHeight) {
                  roomLeftToScroll =
                    totalScrollHeight - (currentScroll + containerHeight);
                  newScrollTop = Math.min(
                    currentScroll + thumbnailHeight,
                    currentScroll + roomLeftToScroll
                  );
                }
              } else {
                if (currentScroll > 0) {
                  roomLeftToScroll = totalScrollHeight - currentScroll;
                  newScrollTop = Math.max(
                    currentScroll - thumbnailHeight,
                    -roomLeftToScroll
                  );
                }
              }
              if (newScrollTop) {
                thumbnailsContainer.scrollTo({
                  top: newScrollTop,
                  behavior: "smooth",
                });
              }
            }
          }
        }
        function setActiveMediaItem(mediaId, updateThumbnailsOnly = false) {
          const prevThumbnail = document.getElementsByClassName(
            "p-main-thumbnail is-selected"
          )[0];
          const newThumbnail = document.querySelector(
            `.p-main-thumbnail[data-media-id="${mediaId}"]`
          );
          prevThumbnail.classList.remove("is-selected");
          newThumbnail.classList.add("is-selected");
          if (!updateThumbnailsOnly) {
            slider.selectCell(
              `.p-main-media-item[data-media-id="${mediaId}"]`,
              false,
              false
            );
          }
          const model = document.querySelector(
            `product-model[data-media-id="${mediaId}"]`
          );
        }
        function setupStickyScroll() {
          updateMediaHeight();
          PLUG.events.target.addEventListener(
            "windowResize",
            updateMediaHeight
          );
          function updateMediaHeight() {
            if (!U.isMobile()) {
              productMainMedia.style.height = "";
              setTimeout(function () {
                if (!U.isMobile()) {
                  const sliderHeight =
                    sliderContainer.getBoundingClientRect().height;
                  productMainMedia.style.height = sliderHeight + "px";
                }
              }, 50);
            } else {
              productMainMedia.style.height = "";
            }
          }
        }
        function setupModelModal() {
          const modalTriggerButtons = Array.from(
            document.getElementsByClassName("p-model-modal-trigger-btn")
          );
          const modelModalEle = document.getElementById("product-model-modal");
          const modelModal = Modal.init(modelModalEle);
          modalTriggerButtons.forEach((button) => {
            button.addEventListener("click", () => {
              const mediaItem = button.closest(".p-main-media-item");
              const mediaId = mediaItem.dataset.mediaId;
              modelModalEle
                .querySelectorAll(".ratio-box")
                .forEach((ratioBox) => {
                  ratioBox.classList.add("is-hidden");
                });
              modelModalEle
                .querySelector(`.ratio-box[data-media-id="${mediaId}"]`)
                .classList.remove("is-hidden");
              const model = modelModalEle.querySelector(
                `product-model[data-media-id="${mediaId}"]`
              );
              if (model) {
                setTimeout(function () {
                  model.loadContent();
                  modelModal.open();
                }, 0);
              }
            });
          });
        }
        function setupModelAr() {
          const arButtons = document.querySelectorAll(
            ".product-model-modal-models .shopify__xr-button"
          );
          arButtons.forEach((arButton) => {
            arButton.addEventListener("click", () => {
              arButton.parentElement.querySelector("model-viewer").activateAR();
            });
          });
        }
        return Object.freeze({ setActiveMediaItem });
      }
      function ProductOptions() {
        // const optionSelectors = productForm.getElementsByClassName("p-main-option-selector");
        const optionSelectors = document.querySelectorAll('.p-main-option-selector');
        const inventoryJSON = JSON.parse(
          document.getElementById("product-inventory-json").innerHTML
        ).variants;
        (function init() {
          try {
            let k = 0;
            while (k < optionSelectors.length) {
              const optionSelectorK = optionSelectors[k];
              console.log(`Processing option selector ${k + 1} of ${optionSelectors.length}`, optionSelectorK);
              if (optionSelectorK.dataset.inputType === "listbox") {
                setupOptionListbox(optionSelectorK);
              } else {
                setupOptionRadioGroup(optionSelectorK);
              }
              k += 1;
            }
          } catch (exception) {
            console.log("Error setting up product options.", exception);
          }
        })();
        function setupOptionListbox(optionSelector) {
          const listbox = optionSelector.getElementsByClassName("listbox")[0];
          return U.listboxConstructor(
            listbox,
            function onChange(selectedOptionEle) {
              onOptionChange(
                optionSelector.dataset.optionPosition,
                selectedOptionEle.textContent.trim()
              );
            }
          );
        }
        function setupOptionRadioGroup(optionSelector) {
          const radioGroup =
            optionSelector.getElementsByClassName("radio-group")[0];
          const radioButtons = radioGroup.querySelectorAll("[role='radio']");
          const activeValueLabel =
            optionSelector.parentElement.getElementsByClassName(
              "p-main-active-value-label"
            )[0];
          let k = 0;
          while (k < radioButtons.length) {
            const radioButtonK = radioButtons[k];
            radioButtonK.addEventListener("click", function () {
              unselectAll();
              radioButtonK.setAttribute("aria-checked", "true");
              if (activeValueLabel) {
                activeValueLabel.textContent = radioButtonK.dataset.value;
              }
              onOptionChange(
                optionSelector.dataset.optionPosition,
                radioButtonK.dataset.value
              );
            });
            k += 1;
          }
          function unselectAll() {
            let k = 0;
            while (k < radioButtons.length) {
              radioButtons[k].setAttribute("aria-checked", "false");
              k += 1;
            }
          }
        }
        function onOptionChange(optionPosition, value) {
          optionPosition = Number(optionPosition);
          const activeVariant = getActiveVariant();
          const options = activeVariant.options
            ? activeVariant.options.slice(0)
            : [];
          options[optionPosition - 1] = value;
          console.log("options",options);
          const newVariant = findVariantByOptions(options);
          console.log("newVariant",newVariant);
          if (newVariant) {
            setActiveVariant(newVariant);
          }
        }
        function findVariantByOptions(options) {
          return product.variants.find(function (variant) {
            return (
              options.length === variant.options.length &&
              options.every(
                (option, index) => option === variant.options[index]
              )
            );
          });
        }
        function setActiveVariant(variant) {
          variantIdSelect.value = variant.id;
          updateHistoryState(variant.id);
          updatePrice(variant);
          if (variant.sku) {
            skuEle.textContent = variant.sku;
            if (specTableSkuEle) {
              specTableSkuEle.textContent = `SKU#: ${variant.sku}`;
            }
          }
          if (variant.featured_media) {
            const mediaId = variant.featured_media.id;
            productMainSubsections.productMedia.setActiveMediaItem(mediaId);
          }
          if (giftCardRecipientForm) {
            giftCardRecipientForm.updateActiveVariantId(variant.id);
          }
          updateInventoryInfo(variant);
        }
        function updateInventoryInfo(variant) {
          const inventoryData = inventoryJSON[String(variant.id)];
          const hasNoQtyLimit =
            inventoryData.inventory_management !== "shopify" ||
            inventoryData.inventory_policy === "continue";
          const productQtyObj = productMainSubsections.productQuantity;
          if (hasNoQtyLimit) {
            addToCartBtn.disabled = false;
            productQtyObj.setMax(false);
            addToCartBtn.textContent = addToCartBtn.dataset.inStockText;
          } else {
            const quantity = productQtyObj.getQuantity();
            const newMax = Number(inventoryData.inventory_quantity);
            productQtyObj.setMax(newMax);
            if (quantity > newMax) {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = addToCartBtn.dataset.outOfStockText;
            } else {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = addToCartBtn.dataset.inStockText;
            }
          }
        }
        function updateHistoryState(variantId) {
          if (!history.replaceState || !variantId) {
            return;
          }
          const newurl =
            location.protocol +
            "//" +
            location.host +
            location.pathname +
            "?variant=" +
            variantId;
          history.replaceState({ path: newurl }, "", newurl);
        }
        return Object.freeze({});
      }
      
     function ProductQuantity() {
        const wrappers = document.getElementsByClassName("p-main-qty-input-wrapper");
      
        Array.from(wrappers).forEach((wrapper) => {
          QuantityInput.init(wrapper, function onChange() {
            updatePrice();
          });
        });
      
        const mainWrapper = wrappers[0];
        const mainInput = mainWrapper?.querySelector(".qty-input");
      
        return {
          getQuantity: () => parseInt(mainInput?.value || 1),
          setMax: (value) => {
            if (!mainInput) return;
            if (value === false) {
              mainInput.removeAttribute('max');
            } else {
              mainInput.setAttribute('max', value);
            }
          }
        };
      }
      
      function ProductAddons() {
        let btns;
        (function init() {
          btns = document.getElementsByClassName(
            "p-main-addon-add-to-cart-btn"
          );
          if (!btns.length) {
            return;
          }
          const addAddonsToCartBtn = document.getElementsByClassName(
            "p-main-add-addons-to-cart-btn"
          )[0];
          U.forEach(btns, function (btn) {
            btn.addEventListener("click", function () {
              if (btn.classList.contains("is-selected")) {
                btn.classList.remove("is-selected");
              } else {
                btn.classList.add("is-selected");
              }
              const selectedBtns = U.filterArray(btns, (btn) =>
                btn.classList.contains("is-selected")
              );
              addAddonsToCartBtn.querySelector("[data-count]").textContent =
                selectedBtns.length;
              addAddonsToCartBtn.disabled = !selectedBtns.length;
            });
          });
          addAddonsToCartBtn.addEventListener("click", function () {
            U.setButtonLoadingState(addAddonsToCartBtn, true);
            const selectedBtns = U.filterArray(btns, (btn) =>
              btn.classList.contains("is-selected")
            );
            if (selectedBtns.length) {
              const itemsToAdd = selectedBtns.map(function (btn) {
                return { id: Number(btn.dataset.variantId), quantity: 1 };
              });
              U.addItemsToCart(itemsToAdd, function (data, reason) {
                if (reason) {
                  U.setButtonLoadingState(addAddonsToCartBtn, false);
                  throw reason;
                }
                Cart.refresh(function (data, reason) {
                  U.setButtonLoadingState(addAddonsToCartBtn, false);
                  if (reason) throw reason;
                  selectedBtns.forEach(function (btn) {
                    btn.classList.remove("is-selected");
                  });
                  addAddonsToCartBtn.disabled = true;
                  addAddonsToCartBtn.querySelector(
                    "[data-count]"
                  ).textContent = 0;
                  Cart.open();
                });
              });
            }
          });
        })();
        return Object.freeze({});
      }
      function updatePrice(activeVariant = getActiveVariant()) {
        const additionalVariantData = variantIdToData[activeVariant.id];
        console.log({ variantIdToData, additionalVariantData, activeVariant });
        const priceCents = ProductCard.computePrice(
          activeVariant.price,
          product.tags
        );
        const compareAtPriceCents = ProductCard.computeCompareAtPrice(
          activeVariant.price,
          activeVariant.compare_at_price,
          product.tags
        );
        const quantity = productMainSubsections.productQuantity.getQuantity();
        priceEle.querySelector(".price__main").textContent = U.formatMoney(
          quantity * priceCents
        );
        if (priceEle.querySelector(".price__unit")) {
          priceEle.querySelector(".price__unit").textContent =
            additionalVariantData.chainLengthFt
              ? ` (${U.formatMoney(
                  priceCents / additionalVariantData.chainLengthFt
                )}/ft.)`
              : "";
        }
        compareAtPriceEle.textContent =
          compareAtPriceCents && priceCents < compareAtPriceCents
            ? U.formatMoney(quantity * compareAtPriceCents)
            : "";
        if (installmentPaymentsMinPrice) {
          installmentPaymentsMinPrice.textContent = U.formatMoney(
            (quantity * priceCents) / 4
          );
        }
      }
      function getActiveVariant() {
        const id = Number(variantIdSelect.value);
        return product.variants.find(function (variant) {
          return variant.id === id;
        });
      }
      function ProductTabMenu() {
        let desktopTabs;
        let mobileTabs;
        let tabContentsWrapper;
        let tabContentWrappers;
        let tabContentInnerWrappers;
        (function init() {
          desktopTabs = document.getElementsByClassName("p-main-tab");
          mobileTabs = document.getElementsByClassName("p-main-tab-mobile");
          tabContentsWrapper =
            document.getElementsByClassName("p-main-tab-menus")[0];
          tabContentWrappers =
            document.getElementsByClassName("p-main-tab-content");
          tabContentInnerWrappers = document.getElementsByClassName(
            "p-main-tab-inner-content"
          );
          setupDesktopTabs();
          setupMobileTabs();
          setupDownloadLinks();
          PLUG.events.target.addEventListener(
            "mobileToDesktopResize",
            setupDesktopTabs
          );
          PLUG.events.target.addEventListener(
            "desktopToMobileResize",
            setupMobileTabs
          );
        })();
        function setupDesktopTabs() {
          if (!desktopTabs[0].classList.contains("is-initialized")) {
            (function setupDesktopTab(k) {
              const tabK = desktopTabs[k];
              if (tabK) {
                const name = tabK.dataset.name;
                const desktopTabBtnK = tabK.getElementsByTagName("button")[0];
                desktopTabBtnK.addEventListener("click", function () {
                  setActiveTab(name);
                });
                tabK.classList.add("is-initialized");
                return setupDesktopTab(k + 1);
              }
            })(0);
          }
          tabContentsWrapper.style.height =
            tabContentsWrapper.getBoundingClientRect().height + "px";
        }
        function setupMobileTabs() {
          if (!mobileTabs[0].classList.contains("is-initialized")) {
            let k = 0;
            while (k < mobileTabs.length) {
              const mobileTabK = mobileTabs[k];
              const name = mobileTabK.parentElement.dataset.name;
              mobileTabK.addEventListener("click", function () {
                if (mobileTabK.parentElement.classList.contains("is-active")) {
                  closeAllMobileTabs();
                } else {
                  setActiveTab(name);
                }
              });
              mobileTabK.classList.add("is-initialized");
              k += 1;
            }
          }
          if (U.isMobile()) {
            tabContentsWrapper.style.height = "";
          }
        }
        function setActiveTab(name) {
          let oldContent = document.querySelector(
            ".p-main-tab-content.is-active"
          );
          const newContent = document.querySelector(
            `.p-main-tab-content[data-name="${name}"]`
          );
          if (!U.isMobile()) {
            measureTabContentHeight(newContent, function (height) {
              setActiveDesktopTab();
              setActiveMobileTab();
              if (!oldContent) {
                oldContent = tabContentWrappers[0];
              }
              oldContent.classList.remove("is-active");
              newContent.classList.add("is-active");
              U.afterNextRepaint(function () {
                tabContentsWrapper.style.height = height + "px";
              });
            });
          } else {
            setActiveDesktopTab();
            setActiveMobileTab();
          }
          function setActiveMobileTab() {
            const oldContentWrapper = document.querySelector(
              ".p-main-tab-content.is-active"
            );
            const newContentWrapper = document.querySelector(
              ".p-main-tab-content[data-name='" + name + "']"
            );
            const newInnerWrapper = newContentWrapper.getElementsByClassName(
              "p-main-tab-inner-content"
            )[0];
            if (oldContentWrapper) {
              const oldInnerWrapper = oldContentWrapper.getElementsByClassName(
                "p-main-tab-inner-content"
              )[0];
              oldContentWrapper.classList.remove("is-active");
              oldInnerWrapper.style.display = "";
            }
            newInnerWrapper.style.display = "block";
            setTimeout(function () {
              newContentWrapper.classList.add("is-active");
            }, 25);
          }
          function setActiveDesktopTab() {
            const oldDesktopTab = document.querySelector(
              ".p-main-tab.is-selected"
            );
            const newDesktopTab = document.querySelector(
              `.p-main-tab[data-name="${name}"]`
            );
            oldDesktopTab.classList.remove("is-selected");
            newDesktopTab.classList.add("is-selected");
          }
        }
        function measureTabContentHeight(tabContentEle, cb) {
          let height;
          if (tabContentEle.classList.contains("is-active")) {
            height = tabContentEle.getBoundingClientRect().height;
            return cb(height);
          }
          tabContentEle.classList.add("is-being-measured");
          U.afterNextRepaint(function () {
            height = tabContentEle.getBoundingClientRect().height;
            tabContentEle.classList.remove("is-being-measured");
            return cb(height);
          });
        }
        function closeAllMobileTabs() {
          let k = 0;
          while (k < tabContentWrappers.length) {
            tabContentWrappers[k].classList.remove("is-active");
            tabContentInnerWrappers[k].style.display = "";
            k += 1;
          }
        }
        function setupDownloadLinks() {
          const downloadInstructionLinks = document.getElementsByClassName(
            "p-main-instructions-download-link"
          );
          let k = 0;
          while (k < downloadInstructionLinks.length) {
            setDownloadLink(downloadInstructionLinks[k]);
            k += 1;
          }
          function setDownloadLink(link) {
            link.addEventListener("click", function () {
              if (!link.href || link.href === "" || link.href === "#") {
                downloadPDF(link, link.dataset.href);
              }
            });
          }
        }
        function downloadPDF(link, url) {
          U.toDataUrl(url, function (dataUrl, reason) {
            if (reason) throw reason;
            link.href = dataUrl;
            link.click();
            setTimeout(function () {
              link.href = "";
            }, 300);
          });
        }
        return Object.freeze({});
      }
      function addToCart() {
        let lineItemProperties = {};
        if (
          window.pn &&
          window.pn.settings &&
          window.pn.settings.singleProductSettings
        ) {
          const settingsObject = window.pn.settings.singleProductSettings.find(
            function (obj) {
              return obj.handle === product.handle;
            }
          );
          if (
            settingsObject &&
            settingsObject.a === addToCartBtn.getAttribute("value")
          ) {
            lineItemProperties["PN-Note"] = "Pre-order Item";
          }
        }
        try {
          if (productForm && giftCardRecipientForm) {
            const fd = new FormData(productForm);
            for (const pair of fd.entries()) {
              const key = pair[0];
              const value = pair[1];
              if (key.includes("properties[")) {
                lineItemProperties[
                  key.replace("properties[", "").replace("]", "")
                ] = value;
              }
            }
          }
        } catch (exception) {
          console.error(exception);
        }
        U.setButtonLoadingState(addToCartBtn, true);
        U.addItemToCart(
          Number(variantIdSelect.value),
          Number(quantityInput.value),
          function updateAndShowCart(data, reason) {
            if (reason) {
              U.setButtonLoadingState(addToCartBtn, false);
              if (giftCardRecipientForm) {
                giftCardRecipientForm.onCartError("Error", reason);
              }
              throw reason;
            }
            if (giftCardRecipientForm) {
              giftCardRecipientForm.resetRecipientForm();
            }
            Cart.refresh(function (data, reason) {
              U.setButtonLoadingState(addToCartBtn, false);
              if (reason) throw reason;
              Cart.open();
            });
          },
          lineItemProperties
        );
      }
      return Object.freeze({});
    }
    function ProductVideos() {
      const section = document.getElementsByClassName("p-videos")[0];
      const modalEle = document.getElementById("product-videos-modal");
      if (!section || !modalEle) {
        return;
      }
      const iframeWrappers = section.getElementsByClassName(
        "youtube-video-iframe-wrapper"
      );
      const iframes = section.getElementsByClassName("ratio-video");
      const playBtns = section.getElementsByClassName("play-btn");
      const numVideos = iframeWrappers.length;
      const ytPlayers = [];
      let modal;
      let slider;
      (function init() {
        try {
          modal = Modal.init(modalEle, {
            onClose: function () {
              ytPlayers.forEach(function (ytPlayer) {
                if (ytPlayer && ytPlayer.pauseVideo) {
                  ytPlayer.pauseVideo();
                }
              });
            },
          });
          if (numVideos > 3 || (numVideos > 1 && window.innerWidth < 840)) {
            slider = createSlider();
          }
          setupVideoModal();
          PLUG.events.target.addEventListener(
            "mobileToDesktopResize",
            function () {
              if (numVideos < 4) {
                slider.destroy();
                slider = undefined;
              }
            }
          );
          PLUG.events.target.addEventListener(
            "desktopToMobileResize",
            function () {
              if (numVideos > 1 && !slider) {
                slider = createSlider();
              }
            }
          );
        } catch (exception) {
          console.log("Error setting up product videos", exception);
        }
      })();
      function createSlider() {
        return new Flickity(
          section.getElementsByClassName("p-videos-preview-image-wrappers")[0],
          {
            cellAlign: "left",
            wrapAround: false,
            contain: true,
            pageDots: false,
            arrowShape: sliderArrowShape,
          }
        );
      }
      function setupVideoModal() {
        const iframeWrappers = modalEle.getElementsByClassName(
          "youtube-video-iframe-wrapper"
        );
        const iframeProperties = {
          class: "ratio-video",
          type: "text/html",
          width: 640,
          height: 360,
          allow: "fullscreen",
          frameborder: 0,
        };
        let ytIframeApiScript;
        U.forEach(playBtns, function (btn, btnIndex) {
          btn.addEventListener("click", function () {
            U.addClasses(iframeWrappers, "is-hidden");
            const iframeWrapper = iframeWrappers[btnIndex];
            iframeWrapper.classList.remove("is-hidden");
            modal.open();
            if (!iframeWrapper.querySelector("iframe")) {
              if (!ytIframeApiScript) {
                ytIframeApiScript = document.createElement("script");
                ytIframeApiScript.id = "youtube-iframe-api-script";
                ytIframeApiScript.src = "https://www.youtube.com/iframe_api";
                const firstScriptTag =
                  document.getElementsByTagName("script")[0];
                firstScriptTag.parentNode.insertBefore(
                  ytIframeApiScript,
                  firstScriptTag
                );
              }
              U.waitUntilTrue(
                function test() {
                  return window.YT && typeof window.YT.Player === "function";
                },
                function done(data, err) {
                  if (err) {
                    console.error(err);
                    return;
                  }
                  ytPlayers[btnIndex] = new YT.Player(
                    document.getElementById(
                      "pdp-yt-replace-" + iframeWrapper.dataset.videoId
                    ),
                    {
                      videoId: iframeWrapper.dataset.videoId,
                      width: "640",
                      height: "360",
                      playerVars: { playsinline: 1 },
                      events: { onReady: onPlayerReady },
                    }
                  );
                },
                100,
                50
              );
            }
          });
        });
        function onPlayerReady(event) {
          event.target.mute();
          event.target.playVideo();
        }
      }
      return Object.freeze({});
    }
    function ProductCollage() {
      const section = document.getElementsByClassName("p-collage")[0];
      const blocks = section.querySelectorAll(
        ".p-collage-block, .p-collage-double-block"
      );
      const buttons = section.getElementsByClassName("p-collage-img-wr");
      const numExtraRows =
        blocks.length <= 7 ? 0 : Math.ceil((blocks.length - 7) / 5);
      let visibleNumExtraRows = 0;
      (function init() {
        let k = 0;
        while (k < buttons.length) {
          setupButton(buttons[k]);
          k += 1;
        }
      })();
      function setupButton(button) {
        button.addEventListener("click", function () {
          if (
            button.parentElement.classList.contains("is-showing-load-more-btn")
          ) {
            showNextRow();
          }
        });
      }
      function showNextRow() {
        const seeMoreBlock = section.getElementsByClassName(
          "p-collage-block is-showing-load-more-btn"
        )[0];
        seeMoreBlock.classList.remove("is-showing-load-more-btn");
        const numVisibleBlocks = 7 + visibleNumExtraRows * 5;
        const isLastRow = numExtraRows - 1 === visibleNumExtraRows;
        if (isLastRow) {
          let k = numVisibleBlocks;
          while (k < blocks.length) {
            if (blocks[k]) {
              blocks[k].parentElement.classList.remove("is-hidden");
            } else {
              break;
            }
            k += 1;
          }
        } else {
          const seeMoreText = U.extractElement(
            seeMoreBlock.getElementsByClassName("p-collage-see-more-text")[0]
          );
          let n = 0;
          while (n < 5) {
            const blockN = blocks[numVisibleBlocks + n];
            if (n === 4) {
              blockN
                .getElementsByClassName("ratio-box")[0]
                .appendChild(seeMoreText);
              blockN.classList.add("is-showing-load-more-btn");
            }
            blockN.classList.remove("is-hidden");
            n += 1;
          }
        }
      }
      return Object.freeze({});
    }
    function ProductArticles() {
      if (!document.getElementById("product-articles")) {
        return;
      }
      const articlesSection = document.getElementsByClassName("p-articles")[0];
      const articlesSliderEle =
        document.getElementsByClassName("p-articles-slider")[0];
      (function init() {
        if (
          !articlesSection.getElementsByClassName(
            "p-articles-single-article"
          )[0]
        ) {
          initArticlesSlider();
        }
      })();
      function initArticlesSlider() {
        try {
          new Flickity(articlesSliderEle, {
            cellAlign: "left",
            wrapAround: true,
            pageDots: false,
            arrowShape: sliderArrowShape,
          });
        } catch (exception) {
          console.log("Error initializing recommendations slider.", exception);
          articlesSection.classList.add("is-hidden");
        }
      }
      return Object.freeze({});
    }
    function ProductRecommendations() {
      const productHandlesToNeverRecommend = ["navidium-shipping-protection"];
      let recsSliderSection = document.getElementsByClassName("p-recs")[0];
      let recsSliderEle = recsSliderSection.getElementsByClassName(
        "product-card-slider"
      )[0];
      (function init() {
        fetchRecommendations(function (data, reason) {
          if (reason) {
            console.error(reason);
            return;
          }
          recsSliderSection = document.getElementsByClassName("p-recs")[0];
          recsSliderEle = recsSliderSection.getElementsByClassName(
            "product-card-slider"
          )[0];
          const recommendationInfoSlides = Array.from(
            recsSliderSection.getElementsByClassName("recommended-product-info")
          );
          const numSlides = recommendationInfoSlides.length;
          const docFrag = document.createDocumentFragment();
          recommendationInfoSlides.forEach(function (slide) {
            const scripts = slide.getElementsByTagName("script");
            const slideProductData = JSON.parse(scripts[0].innerHTML);
            const slideReviewsData = JSON.parse(scripts[1].innerHTML);
            const priceOptions = {};
            if (scripts.length > 2) {
              const chainLength = JSON.parse(
                scripts[2].innerHTML
              ).chainLengthFt;
              if (
                chainLength &&
                typeof chainLength === "number" &&
                chainLength > 0
              ) {
                priceOptions.chainLengthFt = chainLength;
              }
            }
            const productCard = ProductCard.build(
              slideProductData,
              slideReviewsData,
              priceOptions
            );
            slide.parentElement.removeChild(slide);
            if (
              !productHandlesToNeverRecommend.includes(slideProductData.handle)
            ) {
              docFrag.appendChild(productCard);
            }
          });
          recsSliderEle.appendChild(docFrag);
          if (numSlides > 0) {
            if (numSlides <= 4) {
              recsSliderEle.dataset.moreThanFourSlides = "false";
            }
            ProductCardSlider.init(recsSliderEle, {}, true);
          }
          U.updateAllFavoriteButtons();
        });
      })();
      function fetchRecommendations(cb) {
        fetch(
          `${window.Shopify.routes.root}recommendations/products?product_id=${product.id}&section_id=product-recommendations`
        )
          .then((res) => res.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(".p-recs");
            if (recommendations && recommendations.innerHTML.trim().length) {
              recsSliderSection.innerHTML = recommendations.innerHTML;
            }
            return cb();
          })
          .catch((err) => cb(undefined, err));
      }
      return Object.freeze({});
    }
    function ProductCompare() {
      const section = document.getElementsByClassName("p-compare")[0];
      if (!section) {
        return;
      }
      let ratingBadges;
      (function init() {
        try {
          ratingBadges = section.getElementsByClassName(
            "p-compare-item-rating-overview"
          );
        } catch (exception) {
          console.log("Error setting up the product compare section.");
        }
      })();
      return Object.freeze({});
    }
   
const stickyCart = document.querySelector('.sticky-cart');
const stickyAddTrigger = document.querySelector('.sticky-add-triger');
const loader = stickyCart.querySelector('[data-loader="true"]');
const cartText = stickyCart.querySelector('.cart-text'); // Select "Add to Cart" text

if (stickyCart && stickyAddTrigger && loader && cartText) {
    stickyCart.addEventListener('click', function() {
        // Show loader & hide text
        loader.classList.remove('is-hidden');
        cartText.classList.add('is-hidden'); // Hide "Add to Cart" text

        // Simulate a slight delay before triggering add to cart
        setTimeout(() => {
            stickyAddTrigger.click(); // Trigger the actual add-to-cart button

            // Wait for the add-to-cart action to complete before resetting UI
            setTimeout(() => {
                loader.classList.add('is-hidden');
                cartText.classList.remove('is-hidden'); // Show "Add to Cart" text again
            }, 1500); // Adjust timing based on actual response
        }, 200); // Small delay to ensure the click is registered
    });
}
    
// sticky scroll 

window.addEventListener('scroll', function() {
  const productSubmitButtons = document.querySelector('.p-main-submit-btns');
  const stickySection = document.querySelector('.sticky-section');

  if (!productSubmitButtons || !stickySection) return;

  const rect = productSubmitButtons.getBoundingClientRect();

  if (rect.bottom <= 0) {
    // When productSubmitButtons is completely out of view (scrolled up)
    stickySection.classList.add('visible');
  } else {
    stickySection.classList.remove('visible');
  }
});

  })((PLUG.ProductHPJWTemplate = Object.create(null)));
})();
